import * as typeDefs from './types'
import * as resolvers from './resolvers'

export const schema = {
  typeDefs,
  resolvers
}
